import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const DadibaPundole = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Dadiba Pundole"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Dadiba-Pundole-min.jpg"
                bio="Mr Dadiba Pundole owns one of Mumbai’s oldest commercial art spaces – Pundole Gallery. He began his career as a gallerist in 1980. <br /> Mr Pundole is recognised for his in-depth knowledge of Indian Modernists including V. S. Gaitonde, Akbar Padamsee, S. H. Raza, Ram Kumar, M. F. Husain and F. N. Souza, who were represented by the Pundole Art Gallery in the 1960s. He was a consultant at Sotheby’s for their Modern Indian Art sales from 2005 to 2010. Mr Pundole has introduced the gallery to new avenues and transformed it into a successful auction house."
            />
        </>
    );
};

export default DadibaPundole;